import { Routes, Route, Navigate } from "react-router-dom";

// Layouts
import { AppLayout } from "@/components/layouts";

// Providers
import { UserSyncProvider } from "@/components/providers/UserSyncProvider";

// Pages
import {
  HomePage,
  AppPage,
  SettingsPage,
  SignInPage,
  SignUpPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  SupportPage,
  PrivacyPolicyPage,
  TermsOfServicePage,
  BlogIphoneBabyMonitorPage,
} from "@/pages";

// Hooks
import { usePWA } from "@/hooks";
import { useAppAuth } from "@/components/auth/AuthProvider";

// Components

export function App() {
  // Initialize PWA auto-update
  usePWA();
  const { isLoaded, isSignedIn } = useAppAuth();

  if (!isLoaded) return null;

  if (isSignedIn) {
    return (
        <UserSyncProvider>
          <Routes>
            <Route element={<AppLayout />}>
              {/* Redirect signed-in users away from public pages */}
              <Route path="/" element={<Navigate to="/app" replace />} />
              <Route path="/login/*" element={<Navigate to="/app" replace />} />
              <Route
                path="/signup/*"
                element={<Navigate to="/app" replace />}
              />
              <Route path="/forgot-password" element={<Navigate to="/app" replace />} />
              <Route path="/reset-password" element={<Navigate to="/app" replace />} />

              {/* Main app - handles device setup, baby view, and parent view */}
              <Route path="/app" element={<AppPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />

              {/* Blog Pages */}
              <Route
                path="/blog/how-to-use-existing-iphone-as-baby-monitor"
                element={<BlogIphoneBabyMonitorPage />}
              />
            </Route>
          </Routes>
        </UserSyncProvider>
    );
  }

  return (
      <Routes>
          <Route element={<AppLayout />}>
            {/* Public pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login/*" element={<SignInPage />} />
            <Route path="/signup/*" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />

            {/* Blog Pages */}
            <Route
              path="/blog/how-to-use-existing-iphone-as-baby-monitor"
              element={<BlogIphoneBabyMonitorPage />}
            />

            {/* Protected routes redirect to login */}
            <Route
              path="/app"
              element={<Navigate to="/login" replace />}
            />
            <Route path="/settings" element={<Navigate to="/login" replace />} />
          </Route>
      </Routes>
  );
}
